import type { IHubCatalogVisibility, IHubPackageVisibility } from "@enums";
import type {
  IHubCatalog,
  IHubPackage,
  IHubPackageCatalogRelation,
} from "@models";

export enum CatalogVisibilityUpgradeAction {
  Allowed = "allowed",
  UpgradeCompany = "upgrade_company",
  UpgradePlatformReview = "upgrade_platform_review",
}

export function getCatalogVisibilityUpgradeAction(
  catalogVisibility: IHubCatalogVisibility | string | undefined | null,
  packageVisibility: IHubPackageVisibility | string | undefined | null,
): CatalogVisibilityUpgradeAction {
  if (!catalogVisibility || !packageVisibility) {
    return CatalogVisibilityUpgradeAction.Allowed;
  }

  const catVis = String(catalogVisibility).toLowerCase();
  const pkgVis = String(packageVisibility).toLowerCase();

  if (pkgVis === "private") {
    return CatalogVisibilityUpgradeAction.Allowed;
  }
  if (pkgVis === "company") {
    if (catVis === "platform" || catVis === "company") {
      return CatalogVisibilityUpgradeAction.Allowed;
    }
    return CatalogVisibilityUpgradeAction.UpgradeCompany;
  }
  if (pkgVis === "platform") {
    if (catVis === "platform") {
      return CatalogVisibilityUpgradeAction.Allowed;
    }
    return CatalogVisibilityUpgradeAction.UpgradePlatformReview;
  }

  return CatalogVisibilityUpgradeAction.Allowed;
}

export function isCatalogVisibilityAllowedInPackage(
  catalogVisibility: IHubCatalogVisibility | string | undefined | null,
  packageVisibility: IHubPackageVisibility | string | undefined | null,
): boolean {
  return (
    getCatalogVisibilityUpgradeAction(catalogVisibility, packageVisibility) ===
    CatalogVisibilityUpgradeAction.Allowed
  );
}

export function mergePackageWithCatalogRelation(
  pkg: IHubPackage,
  catalog: IHubCatalog,
): IHubPackage {
  const catalogId = catalog.catalogId ?? 0;
  const catalogVersion = catalog.version ?? 0;
  const newRel: IHubPackageCatalogRelation = {
    ...(pkg.packageId != null && pkg.packageId > 0
      ? { packageId: pkg.packageId }
      : {}),
    catalogId,
    catalogVersion,
  };
  const existing = pkg.catalogRelations ?? [];
  const hasCatalog = existing.some(
    (r) => r.catalogId === catalogId && r.catalogVersion === catalogVersion,
  );
  const catalogRelations = hasCatalog ? existing : [...existing, newRel];
  return {
    ...pkg,
    catalogRelations,
  };
}

export function removePackageCatalogRelation(
  pkg: IHubPackage,
  catalogId: number,
  catalogVersion: number,
): IHubPackage {
  const existing = pkg.catalogRelations ?? [];
  const catalogRelations = existing.filter(
    (r) => !(r.catalogId === catalogId && r.catalogVersion === catalogVersion),
  );
  return {
    ...pkg,
    catalogRelations,
  };
}
